// extracted by mini-css-extract-plugin
export default {"ReadOnlyTextArea":"ReadOnlyTextArea_ReadOnlyTextArea__dIaaR","Borderless":"ReadOnlyTextArea_Borderless__xtx0N","Bordered":"ReadOnlyTextArea_Bordered__8z7WI"};